module.exports = __webpack_public_path__ + "img/UAE-landscape-arabic-portrait.95322588.png";